import { useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import SendDocument from './SendDocument';
import './UploadDocument.scss';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const UploadDocument = () => {
  const pageInfo = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, []);

  return (
    <div>
      <Container>
        <Row className="d-flex justify-content-between align-items-center mb-4 document-heading-container w-90">
          <Col md={8} sm={6} lg={6}>
            <div
              className="sr-only"
              role="heading"
              aria-level={1}
              tabIndex={0}
              ref={pageInfo}
            >
              Send Document Page
            </div>
            <h1 className="content-header" aria-hidden={true}>
              {t('member.upload_document.send')}{' '}
              <span className="content-header-bold">
                {t('member.upload_document.document')}
              </span>
            </h1>
          </Col>
          <Col md={4} sm={6} lg={6} className="button-class mt-4">
            <Link
              to={'/member/messages-documents-notifications'}
              state={{
                sendDocumentBackButton: true,
                comingFrom: 'DashboardUploadIcon',
              }}
            >
              <button
                className="border-0 bg-transparent"
                aria-label="Click View All button to go to documents list page"
              >
                <GenericButton variant="secondary" tabIndex={-1}>
                  {t('member.upload_document.view_all')}
                </GenericButton>
              </button>
            </Link>
          </Col>
        </Row>
      </Container>
      <Container>
        <SendDocument />
      </Container>
    </div>
  );
};

export default UploadDocument;
